import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { showPay } from '../../../data/followup/actions/followup';
import { getShowPay, getData } from '../../../data/followup/selectors/followup';
import PayButton from '../components/PayButton';

class PayButtonContainer extends Component {
    static propTypes = {
        data: PropTypes.object,
        shouldShowPay: PropTypes.bool,
        showPay: PropTypes.func
    };

    handleClick() {
        if (this.props.shouldShowPay) {
            // already active
            return;
        }

        this.props.showPay();
    }

    render() {
        const { shouldShowPay, data } = this.props;

        if (null == data) {
            return null;
        }

        const hide = 'reservation' !== data.type
            || data.pricing.balance.amount <= 0;

        if (hide) {
            return null;
        }

        return (
            <PayButton
                disabled={hide || shouldShowPay}
                onClick={::this.handleClick}
            />
        );
    }
}

export default connect(
    state => ({
        data: getData(state.followup),
        shouldShowPay: getShowPay(state.followup)
    }),
    dispatch => bindActionCreators({ showPay }, dispatch)
)(PayButtonContainer);
